(() => {
  const eventName = 'fotogenio:commerce_event';
  const supported = new Set(['affiliate_click','whatsapp_click','service_lead','view_content','view_service','view_product','contact','social_click','location_click']);
  const safeFields = new Set(['product_id','variant_id','service_id','commerce_mode','purpose','status','quantity','value','currency']);
  const clean = value => typeof value === 'string' ? value.trim().slice(0,160) : null;
  function emit(type, element, details = {}) {
    if (!supported.has(type)) throw new TypeError(`Unsupported Fotogenio storefront event: ${type}`);
    let destination = null;
    if (element instanceof HTMLAnchorElement) {
      try { destination = new URL(element.href, location.origin).hostname; } catch (_) {}
    }
    const safe = Object.fromEntries(Object.entries(details).filter(([key,value]) => safeFields.has(key) && ['string','number','boolean'].includes(typeof value)).map(([key,value]) => [key,typeof value === 'string' ? clean(value) : value]));
    const payload = {event_id:globalThis.crypto?.randomUUID?.() || `fg-${Date.now()}-${Math.random().toString(16).slice(2)}`,event_type:type,occurred_at:new Date().toISOString(),source:'shopify_storefront',page_type:clean(document.body?.dataset.template),product_handle:clean(element?.dataset.productHandle || document.body?.dataset.productHandle),product_id:clean(document.body?.dataset.productId),channel:clean(element?.dataset.channel),destination_domain:destination,...safe};
    document.dispatchEvent(new CustomEvent(eventName,{detail:payload}));
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy?.analyticsProcessingAllowed?.() === true && Array.isArray(window.dataLayer)) window.dataLayer.push({event:eventName,fotogenio:payload});
    return payload;
  }
  document.addEventListener('click',event => {
    const anchor = event.target instanceof Element ? event.target.closest('a') : null;
    if (!anchor) return;
    const explicit = clean(anchor.dataset.fotogenioEvent);
    let type = supported.has(explicit) ? explicit : null;
    if (!type) {
      const href = anchor.getAttribute('href') || '';
      if (/^(https?:\/\/)?(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\//i.test(href)) type='whatsapp_click';
      else if (anchor.relList?.contains('sponsored')) type='affiliate_click';
      else if (/^(mailto:|tel:)/i.test(href)) type='contact';
    }
    if (type) emit(type,anchor);
  });
  window.FotogenioCommerceEvents = Object.freeze({emit,eventName});
  function ready() {
    const pageType = document.body.dataset.template;
    emit(pageType === 'product' ? 'view_product' : 'view_content',null);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {emit('view_service',null,{service_id:entry.target.dataset.fgService});observer.unobserve(entry.target);}
      }),{threshold:.35});
      document.querySelectorAll('[data-fg-service]').forEach(section=>observer.observe(section));
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',ready,{once:true}); else ready();
})();
